import { createSlice } from "@reduxjs/toolkit";
import authOperations from "./auth-operations";

const initialState = {
  user: {
    name: null,
    email: null,
  },
  token: null,
  isLoggedIn: false,
  isRefreshingPage: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: {
    [authOperations.register.fulfilled](state, action) {
      console.log(action.payload);
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = true;
    },
    [authOperations.logIn.fulfilled](state, action) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = true;
    },
    [authOperations.logOut.fulfilled](state) {
      state.user = { name: null, email: null };
      state.token = null;
      state.isLoggedIn = false;
    },
    [authOperations.fetchCurrentUser.pending](state){
      state.isRefreshingPage = true;
    },
    [authOperations.fetchCurrentUser.fulfilled](state, action){
      state.user = action.payload;
      state.isLoggedIn = true;
      state.isRefreshingPage = false;
    },
    [authOperations.fetchCurrentUser.rejected](state){
      state.isRefreshingPage = false;
    }
  },
});

export default authSlice.reducer;
